import {SupportedLocales} from '#types/locale.js';

export const globalAppsLocale = {
  [SupportedLocales.EN]: {
    title: 'Global Apps',
    description:
      'Manage OAuth apps that users can connect across GrowthLoop organizations.',
    create: 'Create OAuth app',
    edit: 'Edit OAuth app',
    empty: 'No global OAuth apps yet',
    emptyDescription:
      'Create an app once, then let each user connect their organization and team.',
    search: 'Search apps',
    noResults: 'No apps match your search.',
    name: 'App name',
    redirect: 'Redirect URL',
    redirectHelp:
      'Use the callback URL supplied by your integration. HTTPS is required except for HTTP loopback IPs such as 127.0.0.1 or [::1]. Wildcards are not allowed.',
    addRedirect: 'Add redirect URL',
    remove: 'Remove',
    scopes: 'Permission scopes',
    apiScope: 'GrowthLoop API (required)',
    marveScope: 'Marve agent',
    scopeHelp:
      'Access follows each connected user’s current GrowthLoop roles and permissions.',
    active: 'Active',
    inactive: 'Inactive',
    enable: 'Allow users to connect',
    newInactive:
      'New apps start inactive. Copy the credentials, configure your integration, then activate the app.',
    revokeNotice:
      'Deactivating this app revokes its existing connections. Users must reconnect after it is reactivated.',
    deactivateSave: 'Deactivate and save',
    save: 'Save changes',
    saving: 'Saving…',
    cancel: 'Cancel',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    credentials: 'Save your app credentials',
    secretHelp: 'Copy the client secret now. It will not be shown again.',
    copyId: 'Copy client ID',
    copySecret: 'Copy client secret',
    copied: 'Copied',
    copyFailed: 'Could not copy. Select and copy the value manually.',
    done: 'I’ve saved the credentials',
    loading: 'Loading global apps…',
    loadError: 'Could not load global apps.',
    saveError: 'Could not save the app.',
    retry: 'Retry',
    denied: 'Global Apps is available to app-level admins only.',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    of: 'of',
  },
  [SupportedLocales.ES]: {
    title: 'Aplicaciones globales',
    description:
      'Administra aplicaciones OAuth que los usuarios pueden conectar entre organizaciones de GrowthLoop.',
    create: 'Crear aplicación OAuth',
    edit: 'Editar aplicación OAuth',
    empty: 'Aún no hay aplicaciones OAuth globales',
    emptyDescription:
      'Crea una aplicación una vez para que cada usuario conecte su organización y equipo.',
    search: 'Buscar aplicaciones',
    noResults: 'Ninguna aplicación coincide con tu búsqueda.',
    name: 'Nombre de la aplicación',
    redirect: 'URL de redirección',
    redirectHelp:
      'Usa la URL de retorno de tu integración. Se requiere HTTPS, excepto para HTTP con direcciones IP de bucle local como 127.0.0.1 o [::1]. No se permiten comodines.',
    addRedirect: 'Añadir URL de redirección',
    remove: 'Eliminar',
    scopes: 'Ámbitos de permisos',
    apiScope: 'API de GrowthLoop (obligatorio)',
    marveScope: 'Agente Marve',
    scopeHelp:
      'El acceso sigue los roles y permisos actuales de cada usuario conectado en GrowthLoop.',
    active: 'Activa',
    inactive: 'Inactiva',
    enable: 'Permitir que los usuarios se conecten',
    newInactive:
      'Las nuevas aplicaciones comienzan inactivas. Copia las credenciales, configura la integración y activa la aplicación.',
    revokeNotice:
      'Desactivar esta aplicación revoca sus conexiones existentes. Los usuarios deberán volver a conectarse después de reactivarla.',
    deactivateSave: 'Desactivar y guardar',
    save: 'Guardar cambios',
    saving: 'Guardando…',
    cancel: 'Cancelar',
    clientId: 'ID de cliente',
    clientSecret: 'Secreto de cliente',
    credentials: 'Guarda las credenciales de tu aplicación',
    secretHelp: 'Copia el secreto de cliente ahora. No se volverá a mostrar.',
    copyId: 'Copiar ID de cliente',
    copySecret: 'Copiar secreto de cliente',
    copied: 'Copiado',
    copyFailed: 'No se pudo copiar. Selecciona y copia el valor manualmente.',
    done: 'He guardado las credenciales',
    loading: 'Cargando aplicaciones globales…',
    loadError: 'No se pudieron cargar las aplicaciones globales.',
    saveError: 'No se pudo guardar la aplicación.',
    retry: 'Reintentar',
    denied:
      'Las aplicaciones globales solo están disponibles para administradores de la aplicación.',
    previous: 'Anterior',
    next: 'Siguiente',
    page: 'Página',
    of: 'de',
  },
};
